"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuideSectionTableBody = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var guideCheckbox_1 = __importDefault(require("./guideCheckbox"));
var guidePieSmall_1 = __importDefault(require("./guidePieSmall"));
var _ = __importStar(require("lodash"));
var guidesDataClient_1 = require("../../clients/guidesDataClient");
var MunicipalityColumn = function (props) {
    var item = props.item, m = props.municipality, sectionDispatch = props.sectionDispatch;
    var checked = item.responses[m.slug].checked;
    var onClick = react_1.useCallback(function () {
        new guidesDataClient_1.GuidesDataClient().updateResponse(item.id, m.slug, !checked)
            .then(function (response) { return sectionDispatch(['UPDATE_WITH_RESPONSE', response]); });
    }, [item, m, checked, sectionDispatch]);
    return React.createElement("td", { className: "municipality-column " + (m.editable ? 'edit' : '') }, m.editable
        ? React.createElement(guideCheckbox_1.default, { onClick: onClick, checked: checked })
        : (checked
            ? React.createElement("span", { className: "check checked" },
                React.createElement("i", { className: "fas fa-check" }))
            : React.createElement("span", { className: "response-no" })));
};
var MobileMunicipality = function (props) {
    var item = props.item, m = props.municipality;
    var checked = item.responses[m.slug].checked;
    return React.createElement("div", null,
        checked
            ? React.createElement("span", { className: "check checked" },
                React.createElement("i", { className: "fas fa-check" }))
            : React.createElement("span", { className: "check" }),
        React.createElement("span", { className: "text" }, m.name));
};
var GuideNoteInput = function (props) {
    var showName = props.showName, municipality = props.municipality, item = props.item, sectionDispatch = props.sectionDispatch;
    var _a = react_1.useState(item.responses[municipality.slug].item_note), text = _a[0], setText = _a[1];
    var textAreaRef = react_1.useRef(null);
    var _b = react_1.useState(undefined), textAreaHeight = _b[0], setTextAreaHeight = _b[1];
    var updateHeight = function () {
        if (textAreaRef.current) {
            if (textAreaRef.current.scrollHeight !== textAreaHeight) {
                setTextAreaHeight(textAreaRef.current.scrollHeight);
            }
        }
    };
    react_1.useEffect(function () { return updateHeight(); });
    var onChange = function (e) { return setText(e.target.value); };
    var onSave = function () {
        new guidesDataClient_1.GuidesDataClient().updateResponse(item.id, municipality.slug, undefined, text !== null && text !== void 0 ? text : undefined)
            .then(function (response) { return sectionDispatch(['UPDATE_WITH_RESPONSE', response]); });
    };
    var onCancel = function () { return setText(item.responses[municipality.slug].item_note); };
    var _c = react_1.useState('none'), buttonDisplay = _c[0], setButtonDisplay = _c[1];
    var onFocus = function () { return setButtonDisplay('block'); };
    var onBlur = function () { return setButtonDisplay('none'); };
    var textAreaId = municipality.slug + "-" + item.id;
    return React.createElement("div", { className: "guide-response" },
        showName && React.createElement("label", { htmlFor: textAreaId }, municipality.name + ":"),
        React.createElement("div", { className: "guide-response-input" },
            React.createElement("textarea", { id: textAreaId, className: "guide-note", style: { height: textAreaHeight }, placeholder: "G\u00F6r en egen anteckning", rows: 1, value: text !== null && text !== void 0 ? text : "", onChange: onChange, onFocus: onFocus, onBlur: onBlur, ref: textAreaRef }),
            React.createElement("div", { className: "guide-buttons", style: { display: buttonDisplay } },
                React.createElement("button", { className: "save", onMouseDown: onSave }, "Spara"),
                React.createElement("button", { className: "cancel", onMouseDown: onCancel }, "Avbryt"))));
};
exports.GuideSectionTableBody = function (props) {
    var section = props.section, municipalities = props.municipalities, includeSweden = props.includeSweden, sectionDispatch = props.sectionDispatch;
    var sectionRows = section.items.map(function (item) {
        var municipalityColumns = municipalities.map(function (m) {
            return React.createElement(MunicipalityColumn, { key: item.id + "-" + m.slug, item: item, municipality: m, sectionDispatch: sectionDispatch });
        });
        var editable = _.filter(municipalities, function (m) { return m.editable; });
        var notesInputs = editable.length === 1
            ? editable[0] && React.createElement(GuideNoteInput, { showName: false, municipality: editable[0], item: item, sectionDispatch: sectionDispatch })
            : editable.map(function (m) { return React.createElement(GuideNoteInput, { key: m.slug, showName: true, municipality: m, item: item, sectionDispatch: sectionDispatch }); });
        return React.createElement("tr", { key: item.id },
            municipalityColumns,
            React.createElement("td", { className: "content" },
                React.createElement("div", null,
                    _.isEmpty(municipalities) ? React.createElement("span", { className: "check" }) : null /* show empty checkbox when just viewing list */,
                    React.createElement("span", null, item.title)),
                React.createElement("div", { className: "mobile-municipalities" }, municipalities.map(function (m) { return React.createElement(MobileMunicipality, { key: m.slug, item: item, municipality: m }); })),
                notesInputs),
            includeSweden && React.createElement("td", null,
                React.createElement("div", { className: "last" },
                    React.createElement(guidePieSmall_1.default, { percentage: item.statistics.checkedCount / item.statistics.totalCount }), item.statistics.checkedCount + "/" + item.statistics.totalCount)));
    });
    return React.createElement("tbody", null, sectionRows);
};
